/**
 * Suleman Tech — client-side hardening (no PII storage, no external calls).
 */
(function () {
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /** Strip control chars / excessive whitespace for user-submitted text. */
  function sanitizeText(value, maxLen) {
    let s = String(value || '')
      .replace(/[\0-\x1f\x7f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (maxLen && s.length > maxLen) s = s.slice(0, maxLen);
    return s;
  }

  /** Only allow same-origin relative paths for links. */
  function safePath(path) {
    const p = String(path || '').trim();
    if (!p.startsWith('/') || p.startsWith('//') || /[\s<>"']/.test(p)) return '/';
    return p;
  }

  window.STSecurity = { escapeHtml, sanitizeText, safePath };
})();
